import { call, fork, takeEvery } from 'redux-saga/effects';
import {
  TAG_ALL_LIST_EXCEL_FILE_NAME,
  TAG_SELECTED_LIST_EXCEL_FILE_NAME,
} from '../../../../constants/service/app/tagConstants';
import CsReviewApi from '../../../../lib/api/cs/review/CsReviewApi';
import { excelDownLoad, setRequestForm } from '../../../../lib/common';
import csReviewActions from './actions';
import toastMsg from '../../../../lib/toastMsg';
import csReviewToastMsg from '../../../../constants/service/toastMsg/csReviewToastMsg';

function* fetchList() {
  /**
   *  [상품 후기 상세] 태그 리스트 전체 엑셀 다운로드
   */
  yield takeEvery(csReviewActions.GET_REVIEW_DETAIL_TAG_ALL_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CsReviewApi.getCsReviewDetailTagAllListDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(csReviewToastMsg.GET_REVIEW_DETAIL_TAG_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

      excelDownLoad(TAG_ALL_LIST_EXCEL_FILE_NAME, result.data.tagAllExcelSheet);
    } catch (e) {
      toastMsg.error(csReviewToastMsg.GET_REVIEW_DETAIL_TAG_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR, e);
    }
  });

  /**
   *  [상품 후기 상세] 태그 리스트 선택 엑셀 다운로드
   */
  yield takeEvery(csReviewActions.GET_REVIEW_DETAIL_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CsReviewApi.getCsReviewDetailTagSelectedListDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(csReviewToastMsg.GET_REVIEW_DETAIL_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

      excelDownLoad(TAG_SELECTED_LIST_EXCEL_FILE_NAME, result.data.tagSelectedExcelSheet);
    } catch (e) {
      toastMsg.error(csReviewToastMsg.GET_REVIEW_DETAIL_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR, e);
    }
  });
}

export default function* csReviewSaga() {
  yield fork(fetchList);
}
